// Action types
export const SUGGEST_NAME_REQUEST = 'SUGGEST_NAME_REQUEST';
export const SUGGEST_NAME_SUCCESS = 'SUGGEST_NAME_SUCCESS';
export const SUGGEST_NAME_FAILURE = 'SUGGEST_NAME_FAILURE';
export const CLEAR_SUGGESTED_NAME = 'CLEAR_SUGGESTED_NAME';

// Action creators
export const suggestName = (prefix = '', postfix = '') => ({
  type: SUGGEST_NAME_REQUEST,
  payload: { prefix, postfix }
});

export const suggestNameSuccess = (name) => ({
  type: SUGGEST_NAME_SUCCESS,
  payload: name
});

export const suggestNameFailure = (error) => ({
  type: SUGGEST_NAME_FAILURE,
  payload: error
});

export const clearSuggestedName = () => ({
  type: CLEAR_SUGGESTED_NAME
});
